__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['digital-payments-biometrics'].baseUrl;
import React from 'react';
import { useSelector } from 'react-redux';
import { RenderModule } from '@americanexpress/one-app/holocron';
import App from './App.jsx';
import { setBiometricsConfig } from './config.js';
import './styles/global.css';
if (typeof document !== 'undefined' && !document.querySelector('meta[name="viewport"]')) {
  const viewport = document.createElement('meta');
  viewport.name = 'viewport';
  viewport.content = 'width=device-width, initial-scale=1';
  document.head.appendChild(viewport);
}
function DpBiometrics() {
  const config = useSelector(state => state.get('config'));
  useSelector(state => state.getIn(['holocron', 'loaded']));
  const destPage = typeof window !== 'undefined' ? window.location.href : '/';
  setBiometricsConfig({
    jweAlgorithm: config && config.get('biometricsJweAlg'),
    jweEncryption: config && config.get('biometricsJweEnc'),
    jweKid: config && config.get('biometricsJweKid'),
    jwePublicJwk: config && config.get('biometricsJwePublicJwk')
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderModule, {
    moduleName: "axp-global-header",
    props: {
      logoutDestPage: destPage,
      loginDestPage: destPage
    }
  }), /*#__PURE__*/React.createElement(App, null), /*#__PURE__*/React.createElement(RenderModule, {
    moduleName: "axp-footer"
  }));
}
DpBiometrics.holocron = {
  name: 'digital-payments-biometrics'
};
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- the CSP builder must not run in the browser bundle
  DpBiometrics.appConfig = require('./modules/root/appConfig.js').default;
}
export default DpBiometrics;
;
if (!global.BROWSER) {
  DpBiometrics.appConfig = Object.assign({}, DpBiometrics.appConfig, {
    appCompatibility: "7.x"
  });
}